import { User } from '../types/user';

export const fio = (user?: User | null): string => {
  if (!user) {
    return '';
  }
  const ar = [user.surname, user.name, user.patronymic].filter((e) => e);
  return ar.join(' ');
};
